import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';

@Injectable()
export class AppGlobal {

  static readonly defaultUsageBienList = [
    { code: 'RP', label: 'Résidence principale' },
    { code: 'RS', label: 'Résidence secondaire' },
    { code: 'IL', label: 'Investissement locatif' },
    { code: 'RCI', label: 'Rachat crédit immobilier supérieur à 60%' },
    { code: 'TR', label: 'Travaux' },
    { code: 'PA', label: 'Primo accèdant' },
    { code: 'IL', label: 'Investissement locatif' }
  ]

  static readonly usageBienFullMiList = [
    { code: 'RP', label: 'Résidence principale' },
    { code: 'RS', label: 'Résidence secondaire' },
    { code: 'RCHI', label: 'Rachat crédit hors immobilier' },
    { code: 'RCII', label: 'Rachat crédit immobilier inférieur à 60%' },
    { code: 'RCI', label: 'Rachat crédit immobilier supérieur à 60%' },
    { code: 'TR', label: 'Travaux' },
    { code: 'RE', label: 'Rachat entreprise' },
    { code: 'PA', label: 'Primo accèdant' },
    { code: 'PP', label: 'Prêt à objet professionnel' },
    { code: 'TRV', label: 'Investissement professionnel' },
    { code: 'IL', label: 'Investissement locatif' },
    { code: 'CC', label: 'Crédit à la Consommation' },
    { code: 'A', label: 'Autre immobilier' },
  ]

  static readonly appConfig = {
    'CELTIQUE': {
      iframe: false,
      title: 'Celtique'
    },
    'SANTIANE': {
      iframe: false,
      title: 'Santiane'
    },
    'PRETAUX': {
      iframe: true,
      title: 'Pretaux'
    },
    'MONCREDIT': {
      iframe: true,
      title: 'MONCREDIT'
    },
    'RACHATDECREDIT': {
      iframe: true,
      title: 'Rachat de credit'
    },
    'EMPRUNTEURIO': {
      iframe: true,
      title: 'emprunteur.io'
    },
    'SIMULATIONDECREDIT': {
      iframe: true,
      title: 'Simulation de credit'
    },
    'LECREDITIMMOBILIER': {
      iframe: true,
      title: 'le credit immobilier'
    },
    'LAPATRIMONIALE': {
      iframe: false,
      title: 'La patrimoniale'
    },
    'SANTORS': {
      iframe: false,
      title: 'Santors'
    },
    'ASHLER-MANSON': {
      iframe: false,
      title: 'Economisez sur votre prêt immobilier grâce à l’assurance',
      meta: 'Comparateur gratuit ! En prenant une assurance en délégation, l’emprunteur immobilier peut réaliser de précieuses économies.'
    },
    'LINXEA': {
      iframe: false,
      title: 'Linxea',
      copyright: 'Copyright © LINXEA',
      products: ['IRIADE', 'NAO', 'SEREVI']
    },
    'ASSU-COURTAGE': {
      iframe: false,
      title: 'Assurance Courtage'
    },
    'ORADEA': {
      iframe: false,
      title: 'Oradea',
      copyright: 'Copyright © 2019 ORADEA',
      products: ['IRIADE']
    },
    'CYRIL-TELLIER': {
      iframe: false,
      title: 'Digital Insure',
      products: ['CNP2', 'CNP']
    },
    'LA-FINANCIERE-DORION': {
      iframe: false,
      title: 'LA FINANCIERE D\'ORION',
      products: ['CNP2', 'IRIADE', 'NAO', 'SEREVI']
    },
    'C2R': {
      iframe: false,
      title: 'C2R',
      products: ['AXA', 'IRIADE', 'NAO', 'ALLAZO', 'MNCAP']
    },
    'AVIVA': {
      iframe: false,
      title: 'AVIVA',
      phone: '02 43 87 04 04',
      products: ['AVIVA']
    },
    'EUROFIL': {
      iframe: false,
      title: 'Eurofil by Aviva',
      phone: '02 76 01 53 14',
      products: ['AVIVA']
    },
    'EUROCRM': {
      iframe: false,
      title: 'Eurocrm',
      products: ['NAO', 'AXA', 'SEREVI', 'ALLAZO', 'MNCAP', 'IRIADE'],
      quotiteDisabled: false
    },
    'EUROCRM-PLATEAU': {
      iframe: false,
      title: 'Eurocrm',
      products: ['NAO', 'AXA', 'SEREVI', 'ALLAZO', 'MNCAP', 'IRIADE', 'CNP2', 'CNP'],
      quotiteDisabled: false
    },
    'PRETTO': {
      iframe: false,
      title: 'Pretto',
      products: ['NAO', 'IRIADE', 'SEREVI', 'ALLAZO', 'MNCAP'],
      quotiteDisabled: false
    },
    'MLB': {
      iframe: false,
      title: 'Wok Assurance',
      products: ['ALLAZO', 'MNCAP', 'NAO', 'IRIADE'],
      quotiteDisabled: false,
      usageBiensTr: AppGlobal.usageBienFullMiList,
    },
    'CPCREDIT': {
      iframe: true,
      title: 'Courtier Privé',
      products: ['NAO', 'IRIADE', 'SEREVI', 'CNP', 'CNP2', 'ALLAZO', 'MNCAP', 'AXA']
    },
    'OPTICOURTAGE': {
      iframe: false,
      title: 'Opticourtage',
      products: ['NAO', 'IRIADE', 'SEREVI', 'ALLAZO', 'MNCAP'],
      maxProductsToDisplay: 3,
      defaultTypeSouscription: { code: 'TR', label: 'TROUVER UNE ASSURANCE' }
    },
    'BGFINANCE': {
      title: 'FUNDUPP',
      products: ['AXA', 'NAO', 'IRIADE', 'SEREVI', 'CNP', 'CNP2', 'ALLAZO', 'MNCAP']
    },
    'EASYBLUE': {
      title: 'EASYBLUE',
      products: ['IRIADE', 'SEREVI', 'ALLAZO', 'MNCAP'],
      meta: 'En prenant une assurance en délégation, vous pouvez réaliser de précieuses économies : venez tester gratuitement !',
      usageBiensTr: AppGlobal.usageBienFullMiList,
    },
    'TACTIC': {
      title: 'Tactic Assurance',
      products: ['AXA', 'IRIADE', 'SEREVI', 'CNP2'],
      meta: 'Réalisez sans plus attendre de belles économies sur vos contrats d\'assurance de prêt grâce à notre comparateur.'
    },
    'MERCER': {
      title: 'Mercer',
      products: ['NAO', 'IRIADE', 'MNCAP', 'ALLAZO'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
    },
    'QUICKWIN': {
      showHeaderAndFooter: false,
      title: 'Substitution assurance emprunteur',
      products: ['NAO', 'MNCAP', 'IRIADE', 'ALLAZO'],
      souscriptionEnligne: false,
      saveDevisEnabled: true,
      b2b: true,
      onlyEconomie: true,
      rebondEnabled: true,
      needAuth: true,
    },
    'ASSUREV': {
      title: 'Assurev',
      products: ['NAO', 'IRIADE', 'ALLAZO'],
      meta: 'Comparateur d\'assurance de prêt. Récupérer du pouvoir d\'achat en économisant sur l\'assurance de son crédit.'
    },
    'SOLUPREV': {
      title: 'SOLUPREV',
      products: ['NAO', 'IRIADE', 'ALLAZO', 'MNCAP', 'SEREVI'],
      meta: 'Assurance emprunteur : économisez des milliers d\'euros en changeant votre contrat. Devis gratuit et sans engagement !',
      usageBiensTr: AppGlobal.usageBienFullMiList
    },
    'NET-INVESTISSMENT': {
      title: 'NET INVESTISSEMENT',
      products: ['NAO', 'IRIADE', 'ALLAZO', 'MNCAP'],
      meta: 'Réalisez des économies importantes, avec une reprise de votre assurance emprunteur (Loi Hamon/Bourquin) ! Devis gratuit et sans engagement',
      usageBiensTr: AppGlobal.usageBienFullMiList,
      textProspect1: 'Économisez jusqu’à 50% sur votre assurance emprunteur',
      logoHeader: false,
      logoFooter: false
    },
    'NOVELIA': {
      title: 'Novelia',
      products: ['NAO', 'IRIADE', 'CNP', 'SEREVI', 'SWISSLIFE', 'ALLAZO', 'MNCAP'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      needAuth: true,
      defaultTypeSouscription: 'NOT_DEFINDED'
    },
    'OPTIMA': {
      title: 'Sweetch',
      iframe: false,
      products: ['NAO', 'IRIADE', 'CNP', 'SEREVI', 'SWISSLIFE', 'ALLAZO', 'MNCAP'],
      meta: 'Comment optimiser le coût de votre assurance emprunteur ? Avec Sweetch, changez gratuitement pour être mieux couvert, tout en payant moins cher !',
      souscriptionEnligne: false,
      subTextProspect: "Estimez vos économies en moins d’une minute"
    },
    'FINAWAY': {
      title: 'Finaway Courtage',
      products: ['AXA', 'NAO', 'IRIADE', 'SEREVI', 'ALLAZO', 'MNCAP'],
      meta: 'En prenant une assurance en délégation, vous pouvez réaliser de précieuses économies : venez tester gratuitement !',
      redirectLink: 'https://www.finaway.fr'
    },
    'LMP': {
      title: 'Silveris',
      souscriptionEnligne: false,
      products: ['AXA', 'IRIADE', 'ALLAZO', 'MNCAP'],
      meta: 'Vos économies en assurance emprunteur ? Testez et chiffrez gratuitement ici avec LMP DUQUAIRE CONSEIL',
    },
    'SANTO': {
      title: 'Santo',
      products: ['AXA', 'ALLAZO', 'MNCAP'],
      meta: 'Renégocier votre Assurance de Prêt et économisez jusqu’à 50% avec Santo',
      courtierInfo: 'Votre contact : Virginie Dupouy : 0661486239  - virginiedupouy@orange.fr'
    },
    'AUMAX': {
      title: 'Aumax',
      products: ['NAO', 'IRIADE', 'ALLAZO', 'MNCAP'],
      meta: 'Avec une assurance emprunteur en délégation, vous pouvez réaliser de précieuses économies : venez tester gratuitement !',
      usageBiensTr: AppGlobal.usageBienFullMiList
    },
    'TOPFROGS': {
      title: 'topfrogs',
      products: ['CNP', 'AXA', 'MNCAP'],
      meta: 'L\'expertise d\'une assurance emprunteur en délégation au meilleur tarif  : venez tester gratuitement !',
      residentEnabled: true,
      usageBiensTr: AppGlobal.usageBienFullMiList
    },
    'CREDITCOURTIERDEFRANCE': {
      title: 'Crédit Courtiers de France',
      products: ['NAO', 'IRIADE', 'AXA', 'MNCAP', 'ALLAZO', 'SEREVI'],
      meta: 'Peut-on changer d\’assurance ? Quels sont les documents nécessaires ? Comment faire ? Crédit Courtier de France vous conseille pour changer d’assureur facilement et rapidement en vous trouvant la meilleure solution pour votre projet.'
    },
    'ABC': {
      title: 'Cabinet d\'assurance ABC Courtage',
      products: ['NAO', 'IRIADE', 'AXA', 'MNCAP', 'ALLAZO', 'SEREVI'],
      meta: 'Situé à La Roche-sur-Yon dans le département de la Vendée (85), le cabinet d\'assurance ABC Courtage est à votre écoute pour toutes demandes.'
    },
    'PLACEDESFINANCES': {
      title: 'Place des Finances',
      products: ['NAO', 'IRIADE', 'SEREVI', 'MNCAP', 'ALLAZO']
    },
    'MIEUXVIVRE': {
      title: 'Mieux vivre votre quotidien',
      products: ['NAO', 'IRIADE', 'MNCAP', 'ALLAZO'],
      meta: 'Avec une assurance emprunteur en délégation, vous pouvez réaliser d\'importantes économies : venez tester gratuitement !',
      usageBiensTr: AppGlobal.usageBienFullMiList
    },
    'JEGAGNE': {
      title: 'Je gagne en assurance',
      products: ['SEREVI','IRIADE', 'NAO', 'ALLAZO', 'MNCAP'],
      meta: 'Gagnez jusqu\'à 10 000€ en moyenne sur votre assurance de prêt. Avec JE GAGNE EN ASSURANCE faites de précieuses économies !',
    },
    'SESAME': {
      title: ' Sésame Assurance',
      products: ['SEREVI','IRIADE', 'NAO', 'ALLAZO', 'MNCAP']
    },
    'CORIM': {
      title: 'CORIM',
      products: ['IRIADE', 'NAO', 'ALLAZO', 'MNCAP'],
      meta: 'Avec une assurance emprunteur en délégation, vous pouvez réaliser de précieuses économies : venez tester gratuitement !',
      usageBiensTr: AppGlobal.usageBienFullMiList,
      souscriptionEnligne: false,
      providerOrias: true      
    },
    'INFINITY': {
      title: 'Infinity',
      products: ['IRIADE', 'NAO', 'ALLAZO', 'MNCAP', 'SEREVI'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      codesApporteur: {
        'infinityassurances1.multinet-inside.fr':'INFINITY1',
        'infinityassurances2.multinet-inside.fr':'INFINITY2',
        'infinityassurances3.multinet-inside.fr':'INFINITY3',
        'infinityassurances4.multinet-inside.fr':'INFINITY4',
        'infinityassurances5.multinet-inside.fr':'INFINITY5'
      }
    },
    'MESALLOCS': {
      iframe: true,
      title: 'MESALLOCS',
      products: ['IRIADE', 'NAO', 'ALLAZO', 'MNCAP'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      meta: 'Avec une assurance emprunteur en délégation, vous pouvez réaliser de précieuses économies : venez tester gratuitement !',
    },
    'VALORAMA': {
      iframe: true,
      title: 'Valorama',
      products: ['IRIADE', 'NAO', 'ALLAZO', 'MNCAP', 'SEREVI'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      meta: 'Souscrivez une délégation d\'assurance emprunteur avec Valorama, et réalisez de précieuses économies : testez nous gratuitement !  **',
      defaultTypeSouscription: { code: 'TR', label: 'TROUVER UNE ASSURANCE' }
    },
    'BMB': {
      title: ' BMB Assurances',
      products: ['IRIADE', 'NAO', 'ALLAZO', 'MNCAP', 'SEREVI'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      meta: 'Heureux ou futur propriétaire ? \n' +
      'Obtenez votre devis en quelques minutes et économisez jusqu\'à 60% de votre cotisation d\'assurance de prêt immobilier.\n' +
      'Avec BMB Assurances : une solution adaptée, des démarches facilitées !',
    },
    'PUECHBLANC-CORE': {
      title: 'PUECHBLANC',
      products: ['IRIADE', 'NAO', 'ALLAZO', 'MNCAP', 'SEREVI'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      souscriptionEnligne: false,
    },
    'PUECHBLANC-POGE': {
      title: 'PUECHBLANC',
      products: ['CNP', 'MNCAP'],
      usageBiensTr: AppGlobal.usageBienFullMiList,
      souscriptionEnligne: false,
    },
    'MONCOURTIER': {
      title: 'Mon Courtier Assure',
      products: ['IRIADE', 'NAO', 'AXA', 'ALLAZO', 'MNCAP', 'SEREVI'],
      iframe: true,
      meta: 'Avec Mon courtier assure, comparez, assurez et économisez sur votre prêt immobilier. Votre nouvelle assurance emprunteur, avec un accompagnement sur la résiliation Hamon et Bourquin.',
      usageBiensTr: AppGlobal.usageBienFullMiList,
      souscriptionEnligne: false,
    }
  };

  static readonly productsList = [
    { code: 'IRIADE', label: 'Iriade Emprunteur' },
    { code: 'NAO', label: 'Avenir Naoassur Emprunteur 2' },
    { code: 'SEREVI', label: 'Serevi Emprunteur Digital' },
    { code: 'CNP2', label: 'CNP Access' },
    { code: 'CNP', label: 'CNP Protect Protect' },
    { code: 'AXA', label: 'Naoassur Emprunteur' },
    { code: 'ALLAZO', label: 'ALLAZO Emprunteur' },
    { code: 'MNCAP', label: 'MNCAP Emprunteur Pro' },
    { code: 'AVIVA', label: 'Aviva' }
  ];

  static distributeur = '';

  static originUrl = null;

  static tokenMi = null;

  static profiles = null;

  static uniqueId = null;

  isIframe(): boolean {
    return AppGlobal.appConfig[environment.codeApporteur].iframe;
  }

  setShowHeaderAndFooter(showHeaderAndFooter: boolean) {
    AppGlobal.appConfig[environment.codeApporteur].showHeaderAndFooter = showHeaderAndFooter;
  }

  isShowHeaderAndFooter() {
    if (AppGlobal.appConfig[environment.codeApporteur].showHeaderAndFooter == undefined)
      return true;
    return AppGlobal.appConfig[environment.codeApporteur].showHeaderAndFooter;
  }

  isBgfinance(): boolean {
    return environment.codeApporteur == 'BGFINANCE';
  }

  getTitle(): string {
    return AppGlobal.appConfig[environment.codeApporteur].title;
  }

  isLinxea() {
    return environment.codeApporteur == 'LINXEA';
  }

  isAviva() {
    return environment.codeApporteur == 'AVIVA' || environment.codeApporteur == 'EUROFIL';
  }

  isNovelia() {
    return environment.codeApporteur == 'NOVELIA';
  }

  getCopyright(): string {
    return (AppGlobal.appConfig[environment.codeApporteur].copyright == undefined) ? 'Copyright © Digital Insure' : AppGlobal.appConfig[environment.codeApporteur].copyright;
  }

  getProducts() {
    if (AppGlobal.appConfig[environment.codeApporteur].products == undefined)
      return ['NAO', 'IRIADE', 'AXA', 'MNCAP', 'ALLAZO', 'SEREVI', 'CNP'];
    else return AppGlobal.appConfig[environment.codeApporteur].products;
  }

  getUsageBiens() {
    if (AppGlobal.appConfig[environment.codeApporteur].usageBiens == undefined)
      return AppGlobal.defaultUsageBienList;
    else return AppGlobal.appConfig[environment.codeApporteur].usageBiens;
  }

  getUsageBiensTr() {
    if (AppGlobal.appConfig[environment.codeApporteur].usageBiensTr == undefined)
      return AppGlobal.defaultUsageBienList;
    else return AppGlobal.appConfig[environment.codeApporteur].usageBiensTr;
  }

  getPhone() {
    return AppGlobal.appConfig[environment.codeApporteur].phone;
  }

  isquotiteDisabled(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].quotiteDisabled == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].quotiteDisabled;
  }

  getMaxProductsToDisplay(): number {
    if (AppGlobal.appConfig[environment.codeApporteur].maxProductsToDisplay == undefined)
      return -1;
    return AppGlobal.appConfig[environment.codeApporteur].maxProductsToDisplay;
  }

  getDefaultTypeSouscription() {
    if (AppGlobal.appConfig[environment.codeApporteur].defaultTypeSouscription == undefined)
      return { code: 'CH', label: 'CHANGER D\'ASSURANCE' };
    return AppGlobal.appConfig[environment.codeApporteur].defaultTypeSouscription;
  }

  getProductTitle(codeProduit) {
    return AppGlobal.productsList.find(t => t.code === codeProduit).label;
  }

  isAshlerManson(): boolean {
    return environment.codeApporteur == 'ASHLER-MANSON';
  }

  getMetaDescription(): string {
    if (AppGlobal.appConfig[environment.codeApporteur].meta == undefined)
      return '';
    return AppGlobal.appConfig[environment.codeApporteur].meta;
  }

  saveDevisEnabled(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].saveDevisEnabled == undefined)
      return true;
    return AppGlobal.appConfig[environment.codeApporteur].saveDevisEnabled;
  }

  isB2B(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].b2b == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].b2b && AppGlobal.uniqueId != 'c.leadweb@cafpi.fr';
  }

  onlyEconomie(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].onlyEconomie == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].onlyEconomie;
  }

  setDistributor(distributeur): void {
    AppGlobal.distributeur = distributeur;
  }

  getDistributor(): String {
    return AppGlobal.distributeur;
  }

  setOriginUrl(originUrl): void {
    AppGlobal.originUrl = originUrl;
  }

  getOriginUrl(): String {
    return AppGlobal.originUrl;
  }

  setTokenMi(tokenMi): void {
    AppGlobal.tokenMi = tokenMi;
  }

  getTokenMi(): String {
    return AppGlobal.tokenMi;
  }

  getTextProspect1(): String {
    if (AppGlobal.appConfig[environment.codeApporteur].textProspect1 == undefined)
      return 'Économisez sur votre assurance emprunteur';
    return AppGlobal.appConfig[environment.codeApporteur].textProspect1;
  }

  isLogoHeaderEnabled(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].logoHeader == undefined)
      return true;
    return AppGlobal.appConfig[environment.codeApporteur].logoHeader;
  }

  isLogoFooterEnabled(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].logoFooter == undefined)
      return true;
    return AppGlobal.appConfig[environment.codeApporteur].logoFooter;
  }

  isNeedAuth() {
    if (AppGlobal.appConfig[environment.codeApporteur].needAuth == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].needAuth;
  }

  isRebondEnabled() {
    if (AppGlobal.appConfig[environment.codeApporteur].rebondEnabled == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].rebondEnabled && AppGlobal.distributeur !== 'CAFPI';
  }

  getCourtierInfo(): string {
    if (AppGlobal.appConfig[environment.codeApporteur].courtierInfo == undefined)
      return null;
    return AppGlobal.appConfig[environment.codeApporteur].courtierInfo;
  }

  souscriptionEnligneEnabled(): boolean {
    if (AppGlobal.appConfig[environment.codeApporteur].souscriptionEnligne == undefined)
      return true;
    return AppGlobal.appConfig[environment.codeApporteur].souscriptionEnligne || AppGlobal.uniqueId == 'c.leadweb@cafpi.fr';
  }

  getSubTextProspect(): String {
    if (AppGlobal.appConfig[environment.codeApporteur].subTextProspect == undefined)
      return "Réalisez votre devis en moins d'1 minute";
    return AppGlobal.appConfig[environment.codeApporteur].subTextProspect;
  }

  getRedirectLink(): any {
    if (AppGlobal.appConfig[environment.codeApporteur].redirectLink == undefined)
      return null;
    return AppGlobal.appConfig[environment.codeApporteur].redirectLink;
  }

  getResidentEnabled(): any {
    if (AppGlobal.appConfig[environment.codeApporteur].residentEnabled == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].residentEnabled;
  }

  isLmp(): boolean {
    return environment.codeApporteur == 'LMP';
  }

  setProfiles(profiles) {
    AppGlobal.profiles = profiles;
  }

  getProfiles(): String {
    return AppGlobal.profiles;
  }

  setUniqueId(uniqueId) {
    AppGlobal.uniqueId = uniqueId;
  }

  getUniqueId(): String {
    return AppGlobal.uniqueId;
  }

  isProviderOriasEnabled() {
    if (AppGlobal.appConfig[environment.codeApporteur].providerOrias == undefined)
      return false;
    return AppGlobal.appConfig[environment.codeApporteur].providerOrias;
  }

  getCodeApporteur(codeApporteur: string, href: string) {
    if (AppGlobal.appConfig[environment.codeApporteur].codesApporteur == undefined)
      return codeApporteur;
    var code = AppGlobal.appConfig[environment.codeApporteur].codesApporteur[href];
    if (code == undefined) return codeApporteur;
    else return code;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.global.ts